import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImpuestosComponent } from './impuestos/impuestos.component';
import { ImpuestosRoutingModule } from './/impuestos-routing.module';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { DeudaComponent } from '../deuda/deuda/deuda.component';


@NgModule({
  imports: [
    CommonModule,
    ImpuestosRoutingModule,
    SharedModule,
    MaterialModule      
  ],
  declarations: [ImpuestosComponent, DeudaComponent],
  entryComponents: [DeudaComponent]
})
export class ImpuestosModule { }
